import { PatientEpisodeViewNS } from '@/pages/PatientDetailsPage/PatientSchedulingTab/PatientEpisodeView/PatientEpisodeVisits.types';
import { atomWithReset } from 'jotai/utils';

export const patientEpisodeViewEpisodeAtom =
    atomWithReset<PatientEpisodeViewNS.PatientEpisode | null>(null);
export const patientEpisodeViewModeAtom = atomWithReset<'calendar' | 'list'>('list');
